<ng-container *ngIf="isLoading">
    <div class="page-loader"></div>
</ng-container>
<div [hidden]="isLoading" class="component-main">
    <div class="content">
        <h1 id="component-title">{{ 'checkout_cart' | myLbTranslate }}</h1>
    </div>
    <div
        #step
        [hidden]="hideSetUpSteps"
        class="step"
        [class.active]="activeStep === 1"
        [class.complete]="activeStep > 1">
        <h3>{{ 'billing'  | myLbTranslate }}</h3>
        <div class="step-content">
            <app-add-billing-contact [stepIndex]="1"></app-add-billing-contact>
        </div>
    </div>
    <div
        #step
        [hidden]="hideSetUpSteps"
        class="step"
        [class.active]="activeStep === 2"
        [class.complete]="activeStep > 2">
        <h3>{{ 'billing_card_details' | myLbTranslate }}</h3>
        <div class="step-content">
            <app-add-payment-method [stepIndex]="2" [newCard]="newCard"></app-add-payment-method>
        </div>
    </div>
    <div
        #step
        [hidden]="hidePurchaseSteps"
        class="step"
        [class.active]="activeStep === 3"
        [class.complete]="activeStep > 3">
        <h3>{{ (activeStep > 3 ? 'checkout_selected_product' : 'checkout_select_product') | myLbTranslate }}</h3>
        <div class="step-content">
            <app-select-product [stepIndex]="3" [priceId]="productId"></app-select-product>
        </div>
    </div>
    <div
        #step
        [hidden]="hidePurchaseSteps"
        class="step"
        [class.active]="activeStep === 4"
        [class.complete]="activeStep > 4">
        <h3>{{ (activeStep > 4 ? 'checkout_selected_payment_card' : 'checkout_select_payment_card') | myLbTranslate }}</h3>
        <div class="step-content">
            <app-select-payment-card *ngIf="activeStep >= 4" [stepIndex]="4"></app-select-payment-card>
        </div>
    </div>
    <div
        #step
        *ngIf="!newCard"
        [hidden]="hidePurchaseSteps"
        class="step"
        [class.active]="activeStep === 5"
        [class.complete]="activeStep > 5">
        <h3>{{ (activeStep < 5 ? 'pending' : 'done') | myLbTranslate }}</h3>
    </div>
    <div
        #step
        *ngIf="newCard"
        class="step"
        [class.active]="activeStep === 5"
        [class.complete]="activeStep > 5">
    </div>
</div>
<div class="component-footer">
    <button id="group-cancel" class="outline" (click)="goBackToBillingOverview()">
        {{ 'cancel' | myLbTranslate }}
    </button>
    <button class="primary" [disabled]="activeStep <= firstVisibleStep" (click)="back()">
        {{ 'back' | myLbTranslate }}
    </button>
    <ng-container *ngIf="activeStep !== numberVisibleSteps && !newCard">
        <button class="primary" [disabled]="!nextButtonValid" (click)="next()">
            {{ 'next' | myLbTranslate }}
        </button>
    </ng-container>
    <!-- Note the -1 on number of visible step, this is because of the empty finial step. -->
    <ng-container *ngIf="activeStep === numberVisibleSteps - 1 && newCard">
        <app-loading-button
            buttonId="add-new-card"
            [isDisabled]="!nextButtonValid"
            [handleLoadingStateExternally]="true"
            buttonText="submit"
            buttonClass="primary"
            [callBack]="triggerSubmitCardButton.bind(this)">
        </app-loading-button>
    </ng-container>
    <ng-container *ngIf="activeStep === numberVisibleSteps && !newCard">
        <app-loading-button
            buttonId="purchase-submit"
            buttonText="purchase"
            buttonClass="primary"
            [callBack]="purchaseSubscription.bind(this)">
        </app-loading-button>
    </ng-container>
</div>
